import { type FC } from 'react';
import { Suspense } from 'react';
import { SettingsButtonOpenInSite, type SettingsButtonOpenInSiteProps } from './SettingsButtonOpenInSite';
import { SettingsButtonOpenInSiteStub } from './SettingsButtonOpenInSiteStub';

export const SettingsButtonOpenInSiteSuspense: FC<SettingsButtonOpenInSiteProps> = (props) => (
    <Suspense fallback={<SettingsButtonOpenInSiteStub />}>
        <SettingsButtonOpenInSite {...props} />
    </Suspense>
);
